import React from 'react';

import SearchField from '@app/components/Forms/SearchField/SearchField';

interface MastheadHeroProps {
	title: string;
	imageSrc: string;
	imageAlt?: string;
	imageSrcWebp?: string;
	imageWidth?: number;
	imageHeight?: number;
}

const MastheadHero: React.FC<MastheadHeroProps> = (props) => (
	<div className="masthead masthead_hero">
		<div className="masthead-wrapper">
			<div className="masthead-body">
				<div className="masthead-body__left">
					<h1 className="masthead-body__title">{props.title}</h1>
					<div className="masthead-body-search">
						<p className="masthead-body-search__text">Find a Lap of Love vet near you</p>
						<SearchField placeholder="Enter your 5-digit ZIP code" iconLocation widthBorder="0" searchBody="/find-a-vet/search" />
					</div>
				</div>
				<div className="masthead-body__image-flat">
					<picture>
						<source className="masthead-body__image-content" srcSet={props.imageSrcWebp} type="image/webp" />
						<img
							className="masthead-body__image-content"
							width={props.imageWidth}
							height={props.imageHeight}
							src={props.imageSrc}
							alt={props.imageAlt || ''}
						/>
					</picture>
				</div>
			</div>
		</div>
	</div>
);

export default MastheadHero;
